import { Switch } from 'antd';
import useRetainedTableState from '../hooks/useRetainedTableFilterState';

const ShowDelayedOrdersSwitch = ({
  finalWhereFiltersRef,
  finalWhereFilters,
  setFinalWhereFilters,
  fetchOrders,
  setIsOrderLoading,
  tableFilterKey = null,
  setPaginationProp,
  paginationPropRef,
  setOrderList,
  paginationProp,
  margin,
}) => {
  const { saveRetainedFilterState } = useRetainedTableState();

  const handleFilterChange = (value) => {
    setIsOrderLoading(true);
    setFinalWhereFilters({ ...finalWhereFilters, isDelayed: value });

    if (finalWhereFiltersRef) {
      // eslint-disable-next-line no-param-reassign
      finalWhereFiltersRef.current = {
        ...finalWhereFiltersRef?.current,
        isDelayed: value,
      };
    }

    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    if (paginationPropRef) {
      // eslint-disable-next-line no-param-reassign
      paginationPropRef.current = {
        ...paginationPropRef?.current,
        current: 1,
        skip: 0,
      };
    }

    if (tableFilterKey) {
      saveRetainedFilterState(tableFilterKey, {
        filters: { ...finalWhereFilters, isDelayed: value },
        paginationProp: { ...paginationProp, current: 1, skip: 0 },
      });
    }

    setOrderList([]);
    fetchOrders();
  };

  return (
    <div
      className={`d-flex gap-4 align-center justify-end ${
        margin ? 'mb-16' : ''
      }`}
    >
      <div>Delayed Orders</div>{' '}
      <Switch
        className="m-0 ml-8 mr-8"
        size="small"
        onChange={(value) => handleFilterChange(value)}
        checked={finalWhereFilters?.isDelayed}
      />
    </div>
  );
};

export default ShowDelayedOrdersSwitch;
